import type { MagazineArticleTeaser, MagazineCategory } from '@/lib/api';

export interface MagazineArticleListConfig {
  /** Page size: the first batch and every load-more increment. */
  numberOfItems?: number;
}

/** Which slice of the magazine the grid is showing. */
export type MagazineArticleListFilter =
  | { kind: 'none' }
  | { kind: 'category'; slug: string }
  | { kind: 'author'; slug: string };

/**
 * Resolved by the backend: the block is scoped from the request's tag bag, so
 * the route neither reads this config nor fetches articles on the block's
 * behalf.
 */
export interface MagazineArticleListResolved {
  numberOfItems: number;
  items: MagazineArticleTeaser[];
  total: number;
  categories: MagazineCategory[];
  filter: MagazineArticleListFilter;
  /**
   * The Article Card's featured article, which the first batch left out. Every
   * load-more batch repeats the exclusion — dropping it would let that article
   * reappear and shift every later offset by one.
   */
  exclude?: string | null;
}

export const DEFAULT_NUMBER_OF_ITEMS = 12;
